import React from 'react';
import './CourseCard.css';

function CourseCard({ title, title_front, progress, onClick, is_open_for_everyone }) {
    const [current, total] = progress ? progress.split('/').map(Number) : [0, 1];
    const progressWidth = (current / total) * 100;

    const progressText = progress && current === total ? 'пройдено' : progress;

    const is_open = is_open_for_everyone === false ? "close_for_everyone" : "";

    return (
        <div className={`topic-card ${is_open}`} onClick={onClick}>
            <div className="progress-bar" style={{ width: `${progressWidth}%` }}></div>
            <div className="topic-card-content">
                <h3 className="topic-card-title">{title_front}</h3>
                {progress && <p className="topic-card-progress">{progressText}</p>}
            </div>
        </div>
    );
}

export default CourseCard;
